import { Container, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import HomePage from "../../features/home/HomePage";
import BookDetails from "../../features/catalog/BookDetails";
import ScrollToTop from "../components/ScrollToTop";
import NotFound from "../errors/NotFound";
import Footer from "./Footer";
import Header from "./Header";



function App() {
  var theme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#ffffff'
      },
      background: {
        default: '#ffffff'
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: '#00bed2', // Red background
            color: '#ffffff', // White text for contrast
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position='bottom-right' theme='colored' hideProgressBar />
      <CssBaseline />
      <BrowserRouter>
        <Header />
        <Container maxWidth={false} sx={{width: '100%'}}>
          <ScrollToTop>
            <Routes>
              <Route path='/' element={<HomePage />} />
              <Route path='/book/:id' element={<BookDetails />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ScrollToTop>
        </Container>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
  
}

export default App;
